import Layout from '@/views/layout'

export default [
  {
    path: '/businessAnalysis',
    name: 'businessAnalysis',
    redirect: '/businessAnalysis/businessAnalysis',
    component: Layout,
    meta: {
      title: '经营分析',
      icon: 'workPlant.png',
      index: 1
    },
    children: [
      {
        path: 'businessAnalysis',
        name: 'businessAnalysis',
        meta: {
          title: '经营分析',
          trackName: '经营分析菜单按钮',
          id: '1655798951'
        },
        component: () => import('@/views/businessAnalysis')
      }
    ]
  }
]